// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  let variant = evt.detail.variant;
  let $form = document.querySelector('.quick-product--wrap.is-visible .product-form__controls-group')  || document.querySelector('.product-form__controls-group');
  if (!$form) return;
  $form.classList.toggle('product-form--soldout', !variant.available);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


/*!
 * accounting.js v0.4.2, copyright 2014 Open Exchange Rates, MIT license, http://openexchangerates.github.io/accounting.js
 */
(function(p,z){function q(a){return!!(""===a||a&&a.charCodeAt&&a.substr)}function m(a){return u?u(a):"[object Array]"===v.call(a)}function r(a){return"[object Object]"===v.call(a)}function s(a,b){var d,a=a||{},b=b||{};for(d in b)b.hasOwnProperty(d)&&null==a[d]&&(a[d]=b[d]);return a}function j(a,b,d){var c=[],e,h;if(!a)return c;if(w&&a.map===w)return a.map(b,d);for(e=0,h=a.length;e<h;e++)c[e]=b.call(d,a[e],e,a);return c}function n(a,b){a=Math.round(Math.abs(a));return isNaN(a)?b:a}function x(a){var b=c.settings.currency.format;"function"===typeof a&&(a=a());return q(a)&&a.match("%v")?{pos:a,neg:a.replace("-","").replace("%v","-%v"),zero:a}:!a||!a.pos||!a.pos.match("%v")?!q(b)?b:c.settings.currency.format={pos:b,neg:b.replace("%v","-%v"),zero:b}:a}var c={version:"0.4.1",settings:{currency:{symbol:"$",format:"%s%v",decimal:".",thousand:",",precision:2,grouping:3},number:{precision:0,grouping:3,thousand:",",decimal:"."}}},w=Array.prototype.map,u=Array.isArray,v=Object.prototype.toString,o=c.unformat=c.parse=function(a,b){if(m(a))return j(a,function(a){return o(a,b)});a=a||0;if("number"===typeof a)return a;var b=b||".",c=RegExp("[^0-9-"+b+"]",["g"]),c=parseFloat((""+a).replace(/\((.*)\)/,"-$1").replace(c,"").replace(b,"."));return!isNaN(c)?c:0},y=c.toFixed=function(a,b){var b=n(b,c.settings.number.precision),d=Math.pow(10,b);return(Math.round(c.unformat(a)*d)/d).toFixed(b)},t=c.formatNumber=c.format=function(a,b,d,i){if(m(a))return j(a,function(a){return t(a,b,d,i)});var a=o(a),e=s(r(b)?b:{precision:b,thousand:d,decimal:i},c.settings.number),h=n(e.precision),f=0>a?"-":"",g=parseInt(y(Math.abs(a||0),h),10)+"",l=3<g.length?g.length%3:0;return f+(l?g.substr(0,l)+e.thousand:"")+g.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+e.thousand)+(h?e.decimal+y(Math.abs(a),h).split(".")[1]:"")},A=c.formatMoney=function(a,b,d,i,e,h){if(m(a))return j(a,function(a){return A(a,b,d,i,e,h)});var a=o(a),f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format);return(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal))};c.formatColumn=function(a,b,d,i,e,h){if(!a)return[];var f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format),l=g.pos.indexOf("%s")<g.pos.indexOf("%v")?!0:!1,k=0,a=j(a,function(a){if(m(a))return c.formatColumn(a,f);a=o(a);a=(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal));if(a.length>k)k=a.length;return a});return j(a,function(a){return q(a)&&a.length<k?l?a.replace(f.symbol,f.symbol+Array(k-a.length+1).join(" ")):Array(k-a.length+1).join(" ")+a:a})};if("undefined"!==typeof exports){if("undefined"!==typeof module&&module.exports)exports=module.exports=c;exports.accounting=c}else"function"===typeof define&&define.amd?define([],function(){return c}):(c.noConflict=function(a){return function(){p.accounting=a;c.noConflict=z;return c}}(p.accounting),p.accounting=c)})(this);

const UTILS = (() => {
  const OnElementMutated = (selector, config, callback) => {
    var observer = new MutationObserver(callback);

    // Notify me of everything!
    var observerConfig = {
      attributes: config.attributes || true, 
      childList: config.childList || true, 
      characterData: config.characterData || true 
    };

    // Node, config
    // In this case we'll listen to all changes to body and child nodes
    var targetNodes = document.querySelectorAll(selector);
    targetNodes.forEach(function(node) {
      observer.observe(node, observerConfig);
    });  
  };  

  const OnElementLoad = (selector, callback) => {
    let count = 0
    var t = setInterval(function() {
      var element = document.querySelector(selector);
      count += 100;
      if (
        (element !== null && element !== undefined) || 
        count > 100 * 10 * 3
      ) {
        clearInterval(t);
        callback(element);
      }
    }, 100);
  };

  const AddItemsToCart = (itemsToAdd) => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    });
  };

  const GetCartJson = () => {
    return fetch('/cart.js').then((res) => res.json());
  }

  const RefreshCart = async (item) => {
    let cart = await GetCartJson();
    let purchaseConfirmation = document.querySelector('.purchase-confirmation-popup');
    let isMobile = matchMedia('(max-width:720px)').matches;
    let isCartPage = document.querySelectorAll('.template-cart').length !== 0;

    if (isCartPage) {
      window.location.reload();
      return;
    }

    let r$1 = window.r$1;
    r$1("quick-cart:updated");
    r$1("cart:updated", { cart });

    if (purchaseConfirmation && !isMobile && false) {
    }
    else {
      // Need a delay to allow quick-cart to refresh
      setTimeout(function () {
        r$1("quick-cart:open");

        let $quickModal = document.querySelector('.quick-product--wrap.modal.active');
        if ($quickModal) {
          $quickModal.querySelector('[data-modal-close]').dispatchEvent(new Event('click', {bubbles: true}));
        }
      }, 300);
    }

  }

  const GetLocation = async () => {
    const SESSION_KEY = 'loc_country';
    let location = sessionStorage.getItem(SESSION_KEY);
    if (!location) {
      location = await fetch('/browsing_context_suggestions.json').then(res => res.json());
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(location));
    }
    else {
      location = JSON.parse(location);
    }
    return location;
  }

  const FormatMoney = (value) => {
    return accounting.formatMoney((value / 100), { symbol: "$",  format: "%s %v" });
  }

  return {
    OnElementMutated,
    OnElementLoad,
    AddItemsToCart,
    GetCartJson,
    RefreshCart,
    GetLocation,
    FormatMoney
  };
})();

// Try on toggle
document.addEventListener('init-filter-tryon', (e) => {
  e.currentTarget.addEventListener('click', (evt) => {
    let isMobile = window.matchMedia('(max-width: 479px)').matches;
    let isToggleBtn = (evt.target.classList.contains('tryon-button-img') || 
      evt.target.classList.contains('tryon-button-button') || 
      evt.target.closest('.close-btn') !== null);

    if (isToggleBtn) {
      if (isMobile) {
        let $container = evt.target.closest('[data-tryon_url]');
        let tryon_url = $container.dataset.tryon_url;
        window.open(tryon_url, '_blank');
        return;
      }
      let $tryon = evt.target.closest('.tryon-filter');
      $tryon.classList.toggle('visible');
    }
  });
});

// Gorgias chat links
document.querySelectorAll('[href="#gorgias-chat-open"]').forEach(($link) => {
  $link.addEventListener('click', (e) => {
    e.preventDefault();
    if (window.GorgiasChat) {
      GorgiasChat.open();
    }
  });
});

// Freeship callout based on country
document.addEventListener('alpine:init', () => {
  Alpine.data('freeshipping_callout', () => ({
      settings: null,
      location: null,
      init() {
        let am = this;
        (async() => {
          let location = await UTILS.GetLocation();
          am.location = location;
        })();
      },
      setSettings(settings) {
        this.settings = Object.assign(settings, FS_SETTINGS);
      },
      getThreshold() {
        let am = this;
        let country = am.location ? am.location.detected_values.country.handle : '';
        let isGroup1 = am.settings.group_1_country.replaceAll(', ', ',').split(',').indexOf(country) !== -1;
        let threshold = isGroup1 ? am.settings.group_1_threshold : am.settings.rest_threshold;
        return threshold;
      },
      getMessage() {
        let am = this;
        let message = am.settings.message;
        return message
          .replaceAll('[threshold]', `<span class="money">$${ am.settings.group_1_threshold }</span>`)
          .replaceAll('[threshold2]', `<span class="money">$${ am.settings.rest_threshold }</span>`);
      }
  }))

  // glass prescription calculator
  Alpine.data('ConvertPrescription', () => ({
    $section: null,
    initialized: false,
    init() {
      let am = this;
      document.addEventListener('init-ConvertPrescription', (e) => {
        if (am.initialized) return;

        am.$section = e.target;
        am.initialized = true;
      });
    },
    Convert() {
      let am = this;
      if (!am.$section) return;
      let $section = am.$section;
      // Get input values
      const ODsphere = parseFloat($section.querySelector('#ODsphere').value);
      const ODcylinder = parseFloat($section.querySelector('#ODcylinder').value);
      const ODaxis = parseFloat($section.querySelector('#ODaxis').value);
      const OSsphere = parseFloat($section.querySelector('#OSsphere').value);
      const OScylinder = parseFloat($section.querySelector('#OScylinder').value);
      const OSaxis = parseFloat($section.querySelector('#OSaxis').value);

      // Conversion function
      const convertSphere = (sphere) => {
        if (sphere === 0) {
          return 0;
        } else if (Math.abs(sphere) <= 4) {
          return sphere;
        } else {
          const vertexDistance = 0.012;
          const contactLensSphere = sphere / (1 - (vertexDistance * sphere));
          if (Math.abs(contactLensSphere) < 6) {
            return Math.round(contactLensSphere * 4) / 4;
          } else {
            return Math.round(contactLensSphere * 2) / 2;
          }
        }
      };

      // Calculate contact lens sphere values
      const ODcontactLensSphere = convertSphere(ODsphere);
      const OScontactLensSphere = convertSphere(OSsphere);

      // Set the contact lens sphere values
      $section.querySelector('#ODcontactLensSphere').value = isNaN(ODcontactLensSphere) ? '' : ODcontactLensSphere.toFixed(2);
      $section.querySelector('#OScontactLensSphere').value = isNaN(OScontactLensSphere) ? '' : OScontactLensSphere.toFixed(2);

      // Calculate and set contact lens cylinder and axis values if provided
      if (!isNaN(ODcylinder) && !isNaN(ODaxis)) {
        $section.querySelector('#ODcontactLensCylinder').value = (Math.round(ODcylinder * 4) / 4).toFixed(2);
        $section.querySelector('#ODcontactLensAxis').value = (Math.round(ODaxis / 10) * 10) % 180 || 180;
      } else {
        $section.querySelector('#ODcontactLensCylinder').value = '';
        $section.querySelector('#ODcontactLensAxis').value = '';
      }

      if (!isNaN(OScylinder) && !isNaN(OSaxis)) {
        $section.querySelector('#OScontactLensCylinder').value = (Math.round(OScylinder * 4) / 4).toFixed(2);
        $section.querySelector('#OScontactLensAxis').value = (Math.round(OSaxis / 10) * 10) % 180 || 180;
      } else {
        $section.querySelector('#OScontactLensCylinder').value = '';
        $section.querySelector('#OScontactLensAxis').value = '';
      }
    }
  }));

  // Readmore toggle text
  Alpine.data('ReadMoreToggle', (p_options) => ({
    $section: null,
    p_options: p_options,
    isMobile: matchMedia('(max-width:720px)').matches,
    maxChars: p_options.maxChars,
    selector: p_options.selector,
    init() {
      let am = this;
      document.addEventListener('init-ReadMoreToggle', (e) => {
        if (am.$section) return;

        am.$section = e.target;
        if (am.p_options.desktop && !am.isMobile) {
          am.InitReadMoreToggle();
        }
        if (am.p_options.mobile && am.isMobile) {
          am.InitReadMoreToggle();
        }
      });
    },
    InitReadMoreToggle() {
      let am = this;
      let $content = am.$section.querySelector(am.selector);
      let text = $content.textContent;
      let html = $content.innerHTML;
      if (text.length > am.maxChars) {
        let short_text = text.slice(0, 195);

        $content.textContent = '';
        $content.insertAdjacentHTML('afterbegin', `
          <span class="short-text">${ short_text }... <a class="toggle-link" href="#">More</a></span>
          <span class="full-text">${ html }<a class="toggle-link" href="#">Less</a></span>
        `);

        $content.addEventListener('click', (e) => {
          e.preventDefault();
          if (e.target.classList.contains('toggle-link')) {
            e.stopPropagation();
            $content.classList.toggle('active');
          }
        });
      }
    }
  }));

  // CollapsibleRows
  Alpine.data('CollapsibleRows', () => ({
    $section: null,
    init() {
      let am = this;
      document.addEventListener('init-CollapsibleRows', (e) => {
        if (am.$section) return;

        am.$section = e.target;
        am.ReformatItemsList();
      });
    },
    ReformatItemsList() {
      let am = this;
      let $items = [...am.$section.querySelectorAll('.collapsible-row-list-item')];
      let count = $items.length;
      let midpoint = count / 2;
      $items = [$items.slice(0, midpoint), $items.slice(-midpoint)];

      [1,2].forEach((group_index) => {
        let $group = am.$section.querySelector(`.group--${ group_index }`);
        $items[(group_index - 1)].forEach(($item) => {
          $group.insertAdjacentElement('beforeend', $item);
        });
      });
    }
  }));

  // Pair qty
  Alpine.data('QtyPair', () => ({
    qty: 1,
    pair_id: Date.now(),
    init() {
      this.$watch('qty', () => {
        this.pair_id = Date.now()
      });
    }
  }));

  Alpine.data('ProductPairSelect', () => ({
    product: null,
    cache: {},
    power_R: '0.00 (non prescription)',
    power_L: '0.00 (non prescription)',
    init() {
      this.InitCache();
      this.InitSelf();
      this.InitEvents();
    },
    InitCache() {
      let am = this;
      am.cache.$product_main = am.$el.closest('.quick-product--wrap') || am.$el.closest('.product__details');
      am.cache.$btn_atc = am.cache.$product_main.querySelector('[name=add]');
      am.cache.$qty = am.cache.$product_main.querySelector('[data-quantity-input]');
    },
    InitSelf() {
      let am = this;
      am.product = JSON.parse(am.$el.dataset.product);
    },
    InitEvents() {
      let am = this;
      if (!am.cache.$btn_atc) return;

      let $product_main = am.cache.$product_main;
      let $btn_atc = am.cache.$btn_atc;
      let $qty = am.cache.$qty;

      $btn_atc.classList.remove('btn--secondary');
      $btn_atc.classList.add('btn--primary');

      $btn_atc.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
  
        let $subscribe = $product_main.querySelector('[data-type="subscription"]');
        let isSubscription = ($subscribe && $subscribe.checked) || false;    
  
        let $options = [...$product_main.querySelectorAll('.variant-picker-pairs select')];
        let pair_id = Date.now();
        let itemsToAdd = $options.map(($select) => {
          let variant_id = $select.value;
          let item = {
            quantity: $qty.value,
            id: variant_id,
            properties: {
              'Power R': $options[0].querySelector('option:checked').dataset.title,
              'Power L': $options[1].querySelector('option:checked').dataset.title,
              '_pair': 'true',
              '_pair_id': pair_id
            }
          };
  
          if (isSubscription) {
            let variant = am.product.variants.find(v => variant_id == v.id);
            let selected_frequency_index = $product_main.querySelector('[name=subs_interval]').selectedIndex;
            let selling_plan = variant.selling_plan_allocations[selected_frequency_index];
  
            item.selling_plan = selling_plan.selling_plan_id;
          }
          return item;
        });
        
        let add_req = await UTILS.AddItemsToCart(itemsToAdd);
        if (add_req.ok) {
          UTILS.RefreshCart();
        }
      });  
    }
  }));

  // Cart qty pairs
  Alpine.data('CartQtyPair', (qty, lineitem_key, isPairSeparate) => ({
    qty: qty,
    lineitem_key: lineitem_key,
    isPairSeparate: isPairSeparate,
    init() {
      let am = this;
      am.$watch('qty', am.UpdateQuantity.bind(am));
    },
    UpdateQuantity() {
      let am = this;
      (async() => {
        let cart = await fetch('/cart.js').then(res => res.json());
        let line_item = cart.items.find(item => item.key == am.lineitem_key);
        let qty = am.qty;
        if (!line_item.properties) return;
  
        let updates = {};
        if (!am.isPairSeparate) {
          qty *= 2;
        }
  
        if (am.isPairSeparate) {
          let pair_id = line_item.properties['_pair_id'];
          let line_items_pair = cart.items.filter(item => item.properties && item.properties._pair_id == pair_id);
    
          line_items_pair.forEach((item) => {
            updates[item.key] = qty;
          });  
        }
        else {
          updates[line_item.key] = qty;
        }
  
        console.log(updates)
  
        let update_req = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        });
  
        if (update_req.ok) {
          UTILS.RefreshCart();
        }
        else {
          console.error(update_req);
        }
      })();  
    }
  }));

  // fix - on image change, play/pause video
  document.addEventListener('update-main-image', (e) => {
    let $mediaContainer = e.target.closest('.product__media-container');
    if (!$mediaContainer) return;

    let $video = $mediaContainer.querySelector(`[data-video-id="${ e.detail.id }"] video`);
    if (!$video) {
      // pause all videos in container
      $mediaContainer.querySelectorAll('video').forEach(($video) => {
        $video.pause();
      });
      return;
    };
    
    $video.controls = true;
    $video.play();
  });

  // fix - mobile carousel, on image change, play/pause video
  document.addEventListener('init-media-carousel', (e) => {
    let $mediaContainer = e.target;

    setTimeout(() => {
      let swiper = $mediaContainer.swiper;
      if (!swiper) return;
  
      swiper.on('slideChangeTransitionEnd', () => {
        let $video = $mediaContainer.querySelector('.swiper-slide-active video');
        if (!$video) {
          $mediaContainer.querySelectorAll('video').forEach(($video) => {
            $video.pause();
          });
    
          return;
        }
  
        $video.controls = true;
        $video.play();  
      });  
    }, 2000);
  });

  // output helpers 
  Alpine.data('DATA', (item) => ({
    init() {
      document.querySelectorAll(`[x-data="DATA('${ item }')"]`).forEach(($item) => {
        let replace_text = '';
        switch(item) {
          case 'fs-threshold-1':
            replace_text = FS_SETTINGS.group_1_threshold;
            break;
          case 'fs-threshold-2':
            replace_text = FS_SETTINGS.rest_threshold;
            break;
          case 'country':
            let loc_country = JSON.parse(sessionStorage.getItem('loc_country'));
            replace_text = `${ loc_country.detected_values.country.name }`;
            break;
        }

        $item.textContent = `$${ replace_text }`;
      });
    }
  }));

  Alpine.data('FreeShipBar', () => ({
    config: {
      threshold_1: 0,
      message_1_inc: '',
      message_1_comp: '',
      fg_title: '',
      threshold_2: 0,
      message_2_inc: '',
      message_2_comp: ''
    },
    flags: {
      progress: 0
    },
    cart: null,
    mounted() {
      let am = this
      am.config.threshold_1 = parseFloat(am.$el.dataset.threshold_1) || 0
      am.config.message_1_inc = am.$el.dataset.message_1_inc
      am.config.message_1_comp = am.$el.dataset.message_1_comp
      am.config.fg_title = am.$el.dataset.fg_title

      am.config.threshold_2 = parseFloat(am.$el.dataset.threshold_2) || 0
      am.config.message_2_inc = am.$el.dataset.message_2_inc
      am.config.message_2_comp = am.$el.dataset.message_2_comp

      if (!am.config.threshold_1 && !am.config.threshold_2) {
        am.$el.classList.add('visually-hidden')
      }

      am.config.message_3 = am.$el.dataset.message_3

      am.CheckProgress()

      document.addEventListener("cart:updated", (e) => {
        am.CheckProgress()
      })
    },
    CheckProgress() {
      let am = this;
      (async() => {
        am.cart = await UTILS.GetCartJson()
        let threshold = am.config.threshold_1
        if (am.config.threshold_2 > am.config.threshold_1) {
          threshold = am.config.threshold_2
        }
        am.flags.progress = (am.cart.total_price / threshold) * 100
      })()
    },
    GetProgressStyle() {
      let am = this
      let obj = {}
      obj['--progress-width'] = `${ am.flags.progress }%`
      return obj
    },
    GetProgressMessage() {
      let am = this
      if (!am.cart) return ''

      let msg = []
      if (am.config.threshold_1) {
        let msg_1 
        let progress_1 = (am.cart.total_price / am.config.threshold_1) * 100
        if (progress_1 < 100) {
          let fg_remaining = am.config.threshold_1 - am.cart.total_price
          msg_1 = am.config.message_1_inc.replace('$X', `<strong><span class=money>${ UTILS.FormatMoney(fg_remaining) }</span></strong>`)
          msg_1 = msg_1.replace('$TITLE', `${ am.config.fg_title }`)
        }
        else {
          msg_1 = am.config.message_1_comp
          msg_1 = msg_1.replace('$TITLE', `${ am.config.fg_title }`)
        }
        msg.push(msg_1)
      }
      if (am.config.threshold_2) {
        let msg_2
        let progress_2 = (am.cart.total_price / am.config.threshold_2) * 100
        if (progress_2 < 100) {
          let fs_remaining = am.config.threshold_2 - am.cart.total_price
          msg_2 = am.config.message_2_inc.replace('$X', `<strong><span class=money>${ UTILS.FormatMoney(fs_remaining) }</span></strong>`)
        }
        else {
          msg_2 = am.config.message_2_comp
        }
        msg.push(msg_2)
      }

      if (am.config.threshold_1 > am.config.threshold_2) {
        msg = msg.reverse()
      }

      return msg.join('<br />')
    }
  }))
});